import { createRoutine } from 'redux-saga-routines'

export const getActionsRoutine = createRoutine('GET_ACTIONS')
export const getActionStatsRoutine = createRoutine('GET_ACTION_STATS')
export const getActionRoutine = createRoutine('GET_ACTION')
export const createActionRoutine = createRoutine('CREATE_ACTION')
export const updateActionRoutine = createRoutine('UPDATE_ACTION')
export const convertActionToTaskRoutine = createRoutine('CONVERT_ACTION_TO_TASK')
export const dismissActionRoutine = createRoutine('DISMISS_ACTION')
export const approveActionRoutine = createRoutine('APPROVE_ACTION')
export const reopenActionRoutine = createRoutine('REOPEN_ACTION')
export const bulkDismissActionsRoutine = createRoutine('BULK_DISMISS_ACTIONS')
export const bulkConvertActionsRoutine = createRoutine('BULK_CONVERT_ACTIONS')
export const extractActionsFromFileRoutine = createRoutine('EXTRACT_ACTIONS_FROM_FILE')
export const refreshActionsRoutine = createRoutine('REFRESH_ACTIONS')
export const getActionSectionRoutine = createRoutine('GET_ACTION_SECTION')
export const bulkUpdateActionsRoutine = createRoutine('BULK_UPDATE_ACTIONS')
export const remedialRefreshedRoutine = createRoutine('REMEDIAL_REFRESHED')
export const refreshAllActionStatsRoutine = createRoutine('REFRESH_ALL_ACTION_STATS')
